import { render, staticRenderFns } from "./OrderImage.vue?vue&type=template&id=7e4a99a7"
import script from "./OrderImage.vue?vue&type=script&lang=js"
export * from "./OrderImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports